module.exports = __webpack_public_path__ + "img/0.89d85a4d.png";